import type { SortOption } from "../types";

export const SORT_OPTIONS: SortOption[] = [
  { key: "CREATED_AT", reverse: true, label: "Newest" },
  { key: "RELEVANCE", reverse: false, label: "Recommended" },
  { key: "BEST_SELLING", reverse: false, label: "Best selling" },
  { key: "PRICE", reverse: false, label: "Price: Low to High" },
  { key: "PRICE", reverse: true, label: "Price: High to Low" },
  { key: "TITLE", reverse: false, label: "Name: A to Z" },
];

function optionId(o: SortOption) {
  return `${o.key}:${o.reverse ? "1" : "0"}`;
}

export function sortOptionToParam(o: SortOption): string {
  return optionId(o);
}

export function sortOptionFromParam(param: string | null): SortOption | null {
  if (!param?.trim()) return null;
  return SORT_OPTIONS.find((o) => optionId(o) === param.trim()) ?? null;
}

type Props = {
  value: SortOption;
  onChange: (option: SortOption) => void;
};

export function SortDropdown({ value, onChange }: Props) {
  return (
    <label className="poca-sort">
      <select
        className="poca-sort__select"
        value={optionId(value)}
        onChange={(e) => {
          const next = SORT_OPTIONS.find((o) => optionId(o) === e.target.value);
          if (next) onChange(next);
        }}
      >
        {SORT_OPTIONS.map((o) => (
          <option key={optionId(o)} value={optionId(o)}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
